//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data () {
    return {
      selectVal: ''
      // help_selectVal: false,
      // help_ls: false
    }
  },
  components: {
  },
  computed: {
    helpCenterActive () {
      var result = this.$route.path === '/helpIntro' || this.$route.path === '/video' || this.$route.path === '/questions' || this.$route.path === '/agreement' || this.$route.path === '/complaints'
      return result
    }
  },
  methods: {
    vsChange (val) {
      // this.help_selectVal = true
      this.selectVal = ''
    },
    handleCommand (val) {
      this.$router.push({name: val})
      // this.help_ls = true
    },
    mouseover (val) {
      this.selectVal = val
    },
    handleSelect (val) {
      this.$router.push(val)
      // this.help_ls = false
    },
    handleSelect1 (val) {
      window.open(val)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/layouts/header.vue